export default {
  props: {
    label: null,
    value: null,
    disabled: Boolean,
    returnObject: Boolean,
    error: Boolean,
    errorsMessages: null,
    multiple: Boolean,
    chips: Boolean,
    clearable: Boolean,
    filter: {
      type: Function,
      default: v => v
    },
    initial: null,
    solo: Boolean,
    parseValue: {
      type: Function,
      default: v => {
        if (Array.isArray(v)) {
          return v.map(x => +x);
        }
        return +v;
      }
    }
  }
};
